import { SIGN_IN_CALLBACK_PATH } from "src/auth/dxmSsoConfig";

/** Mirrors the content architecture: Org › Companies › Company › Project › Solution › Model / Build. */
export const ROUTES = {
	home: "/",
	companies: "/companies",
	solutions: "/solutions",
	solutionNew: "/solutions/new",
	solutionDesign: (id: string) => `/solutions/${id}/design`,
	solutionOverview: (id: string) => `/solutions/${id}/overview`,
	explore: "/explore",
	showcases: "/showcases",
	showcase: (id: string) => `/showcases/${id}`,
	company: (id: string) => `/companies/${id}`,
	project: (id: string) => `/projects/${id}`,
	solution: (id: string) => `/solutions/${id}`,
	model: (id: string) => `/models/${id}`,
	build: (id: string) => `/builds/${id}`,
	activity: "/activity",
	notificationSettings: "/settings/notifications",
	members: "/organization/members",
	admin: "/admin",
	adminOrganizations: "/admin/organizations",
	adminUsers: "/admin/users",
	adminRoles: "/admin/roles",
	adminLocationCatalog: "/admin/location-catalog",
	adminMarketing: "/admin/marketing-resources",
	adminFeatureFlags: "/admin/feature-flags",
	adminApiTokens: "/admin/api-tokens",
	/** Where Platform admin and Roles were before the admin console; redirected to it. */
	legacyPlatform: "/platform",
	legacyRoles: "/platform/roles",
	/** Where API tokens were before they joined the admin console; redirected to it. */
	legacyApiTokens: "/account/api-tokens",
	signInCallback: SIGN_IN_CALLBACK_PATH,
	/** Where emailed sign-in links land; must match SIGN_IN_LINK_PATH in the API. */
	signInLink: "/auth/link",
	devLogin: "/dev-login"
} as const;
